import AsyncTypography from 'components/AsyncTypography/AsyncTypography'
import InputSkeleton from './InputSkeleton'
import { useMemo } from 'react'
import ButtonSkeleton from './ButtonSkeleton'
import clsx from 'clsx'
import { WppDivider, WppSkeleton } from '@wppopen/components-library-react'
import styles from './skeletonStyles.module.scss'
import formStyles from 'components/Forms/SettingsForm.module.scss'
import navigationHeaderStyles from 'pages/Settings/NavigationHeader.module.scss'

interface FormSkeletonProps {
  hasNavigation?: boolean
  hasVersioning?: boolean
  hasHeader?: boolean
}

const FormSkeleton = ({ hasVersioning, hasNavigation, hasHeader }: FormSkeletonProps) => {
  const formSection = useMemo(() => {
    return (
      <>
        <AsyncTypography type="xl-heading" tag="h3" isLoading />
        <InputSkeleton />
        <InputSkeleton />
        <InputSkeleton />
      </>
    )
  }, [])

  return (
    <>
      {hasNavigation && (
        <div className={`${navigationHeaderStyles.navigationHeader__container} ${styles.header}`}>
          <WppSkeleton variant="rectangle" width={200} height={20} data-testid="back-navigation-link-skeleton" />
        </div>
      )}
      <div className={styles.formSkeleton__wrapper}>
        {hasHeader && (
          <>
            <AsyncTypography
              type="xs-midi"
              tag="p"
              className={clsx(styles.text_right, styles.skeleton)}
              isLoading={true}
            />
            <div className={styles.formSkeleton__wrapper__header} data-testid="form-header-skeleton">
              <AsyncTypography type="3xl-heading" tag="h1" isLoading={true} />
              <ButtonSkeleton />
            </div>
            {hasVersioning && (
              <AsyncTypography
                type="2xl-heading"
                tag="p"
                className={styles.skeleton}
                isLoading={true}
                dataTestId="version-link-skeleton"
              />
            )}
            <WppDivider className={formStyles.divider} />
          </>
        )}
        <div className={formStyles.form_wrapper} data-testid="form-wrapper">
          {formSection}
          {formSection}
        </div>
      </div>
    </>
  )
}

export default FormSkeleton
